import styled from '@emotion/styled';

interface TypeBadgeProps {
  type: 'run' | 'segment';
  className?: string;
}

export function TypeBadge({ type, className }: TypeBadgeProps): React.JSX.Element {
  return (
    <Badge $type={type} className={className}>
      {type === 'run' ? 'Run' : 'Segment'}
    </Badge>
  );
}

const Badge = styled.span<{ $type: 'run' | 'segment' }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
  white-space: nowrap;
  background: ${(props) =>
    props.$type === 'run'
      ? props.theme.palette.sentiment.primary.lighter
      : props.theme.palette.sentiment.primary.light};
  color: ${(props) =>
    props.$type === 'run'
      ? props.theme.palette.sentiment.primary.main
      : props.theme.palette.sentiment.primary.dark};
`;
